//:: Drawer
export const DRAWER_TOGGLE = 'DRAWER_TOGGLE'
export const DRAWER_SET_SELECTED_KEY = 'DRAWER_SET_SELECTED_KEY'

//:: Login
export const LOGIN_BEGIN = 'LOGIN_BEGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const RECONNECT_BEGIN = 'RECONNECT_BEGIN'
export const RECONNECT_SUCCESS = 'RECONNECT_SUCCESS'
export const RECONNECT_FAILURE = 'RECONNECT_FAILURE'

export const POST_CUSTOMER_BEGIN = 'POST_CUSTOMER_BEGIN'
export const POST_CUSTOMER_SUCCESS = 'POST_CUSTOMER_SUCCESS'
export const POST_CUSTOMER_FAILURE = 'POST_CUSTOMER_FAILURE'

export const LOGOUT = 'LOGOUT'

export const CLEAR_LOGIN_ERROR_STATE = 'CLEAR_LOGIN_ERROR_STATE'

//:: Search
export const GET_SEARCH_EMAIL_BEGIN = 'GET_SEARCH_EMAIL_BEGIN'
export const GET_SEARCH_EMAIL_SUCCESS = 'GET_SEARCH_EMAIL_SUCCESS'
export const GET_SEARCH_EMAIL_FAILURE = 'GET_SEARCH_EMAIL_FAILURE'

export const GET_SEARCH_CNPJ_BEGIN = 'GET_SEARCH_CNPJ_BEGIN'
export const GET_SEARCH_CNPJ_SUCCESS = 'GET_SEARCH_CNPJ_SUCCESS'
export const GET_SEARCH_CNPJ_FAILURE = 'GET_SEARCH_CNPJ_FAILURE'

//:: Customer Related
export const GET_CUSTOMER_INFORMATION_BEGIN = 'GET_CUSTOMER_INFORMATION_BEGIN'
export const GET_CUSTOMER_INFORMATION_SUCCESS = 'GET_CUSTOMER_INFORMATION_SUCCESS'
export const GET_CUSTOMER_INFORMATION_FAILURE = 'GET_CUSTOMER_INFORMATION_FAILURE'

export const POST_CUSTOMER_SOFT_BLOCK_BEGIN = 'POST_CUSTOMER_SOFT_BLOCK_BEGIN'
export const POST_CUSTOMER_SOFT_BLOCK_SUCCESS = 'POST_CUSTOMER_SOFT_BLOCK_SUCCESS'
export const POST_CUSTOMER_SOFT_BLOCK_FAILURE = 'POST_CUSTOMER_SOFT_BLOCK_FAILURE'

export const POST_CUSTOMER_UNBLOCK_BEGIN = 'POST_CUSTOMER_UNBLOCK_BEGIN'
export const POST_CUSTOMER_UNBLOCK_SUCCESS = 'POST_CUSTOMER_UNBLOCK_SUCCESS'
export const POST_CUSTOMER_UNBLOCK_FAILURE = 'POST_CUSTOMER_UNBLOCK_FAILURE'

export const PUT_CUSTOMER_INFO_BEGIN = 'PUT_CUSTOMER_INFO_BEGIN'
export const PUT_CUSTOMER_INFO_SUCCESS = 'PUT_CUSTOMER_INFO_SUCCESS'
export const PUT_CUSTOMER_INFO_FAILURE = 'PUT_CUSTOMER_INFO_FAILURE'

export const PUT_CUSTOMER_ADDRESS_BEGIN = 'PUT_CUSTOMER_ADDRESS_BEGIN'
export const PUT_CUSTOMER_ADDRESS_SUCCESS = 'PUT_CUSTOMER_ADDRESS_SUCCESS'
export const PUT_CUSTOMER_ADDRESS_FAILURE = 'PUT_CUSTOMER_ADDRESS_FAILURE'

export const GET_CUSTOMER_SUBSCRIPTION_BEGIN = 'GET_CUSTOMER_SUBSCRIPTION_BEGIN'
export const GET_CUSTOMER_SUBSCRIPTION_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTION_SUCCESS'
export const GET_CUSTOMER_SUBSCRIPTION_FAILURE = 'GET_CUSTOMER_SUBSCRIPTION_FAILURE'

export const PUT_UPDATE_CUSTOMER_BEGIN = 'PUT_UPDATE_CUSTOMER_BEGIN'
export const PUT_UPDATE_CUSTOMER_SUCCESS = 'PUT_UPDATE_CUSTOMER_SUCCESS'
export const PUT_UPDATE_CUSTOMER_FAILURE = 'PUT_UPDATE_CUSTOMER_FAILURE'
export const CLEAR_UPDATE_CUSTOMER_DATA = 'CLEAR_UPDATE_CUSTOMER_DATA'

//:: Plan
export const GET_AVAILABLE_PLANS_BEGIN = 'GET_AVAILABLE_PLANS_BEGIN'
export const GET_AVAILABLE_PLANS_SUCCESS = 'GET_AVAILABLE_PLANS_SUCCESS'
export const GET_AVAILABLE_PLANS_FAILURE = 'GET_AVAILABLE_PLANS_FAILURE'

export const GET_PLAN_BEGIN = 'GET_PLAN_BEGIN'
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS'
export const GET_PLAN_FAILURE = 'GET_PLAN_FAILURE'

//:: Product
export const GET_ALL_PRODUCTS_BEGIN = 'GET_ALL_PRODUCTS_BEGIN'
export const GET_ALL_PRODUCTS_SUCCESS = 'GET_ALL_PRODUCTS_SUCCESS'
export const GET_ALL_PRODUCTS_FAILURE = 'GET_ALL_PRODUCTS_FAILURE'

export const GET_PRODUCT_BEGIN = 'GET_PRODUCT_BEGIN'
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS'
export const GET_PRODUCT_FAILURE = 'GET_PRODUCT_FAILURE'

export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS'
export const POST_CREATE_PRODUCT_BEGIN = 'POST_CREATE_PRODUCT_BEGIN'
export const POST_CREATE_PRODUCT_SUCCESS = 'POST_CREATE_PRODUCT_SUCCESS'
export const POST_CREATE_PRODUCT_FAILURE = 'POST_CREATE_PRODUCT_FAILURE'

//:: Product Table
export const GET_CURRENT_PRODUCT_TABLE_BEGIN = 'GET_CURRENT_PRODUCT_TABLE_BEGIN'
export const GET_CURRENT_PRODUCT_TABLE_SUCCESS = 'GET_CURRENT_PRODUCT_TABLE_SUCCESS'
export const GET_CURRENT_PRODUCT_TABLE_FAILURE = 'GET_CURRENT_PRODUCT_TABLE_FAILURE'
export const CLEAR_CURRENT_PRODUCT_TABLE_INFO = 'CLEAR_CURRENT_PRODUCT_TABLE_INFO'

export const POST_CREATE_PRODUCT_TABLE_BEGIN = 'POST_CREATE_PRODUCT_TABLE_BEGIN'
export const POST_CREATE_PRODUCT_TABLE_SUCCESS = 'POST_CREATE_PRODUCT_TABLE_SUCCESS'
export const POST_CREATE_PRODUCT_TABLE_FAILURE = 'POST_CREATE_PRODUCT_TABLE_FAILURE'

export const PUT_UPDATE_PRODUCT_TABLE_BEGIN = 'PUT_UPDATE_PRODUCT_TABLE_BEGIN'
export const PUT_UPDATE_PRODUCT_TABLE_SUCCESS = 'PUT_UPDATE_PRODUCT_TABLE_SUCCESS'
export const PUT_UPDATE_PRODUCT_TABLE_FAILURE = 'PUT_UPDATE_PRODUCT_TABLE_FAILURE'

export const INSERT_PRODUCT_TABLE_DATA = 'INSERT_PRODUCT_TABLE_DATA'
export const POST_ADD_PRODUCT_BEGIN = 'POST_ADD_PRODUCT_BEGIN'
export const POST_ADD_PRODUCT_SUCCESS = 'POST_ADD_PRODUCT_SUCCESS'
export const POST_ADD_PRODUCT_FAILURE = 'POST_ADD_PRODUCT_FAILURE'
export const CLEAR_ADDED_PRODUCTS = 'CLEAR_ADDED_PRODUCTS'

export const GET_PRODUCT_TABLES_BEGIN = 'GET_PRODUCT_TABLES_BEGIN'
export const GET_PRODUCT_TABLES_SUCCESS = 'GET_PRODUCT_TABLES_SUCCESS'
export const GET_PRODUCT_TABLES_FAILURE = 'GET_PRODUCT_TABLES_FAILURE'

export const RESET_PRODUCT_TABLE_STATE = 'RESET_PRODUCT_TABLE_STATE'

//:: Marketplace
export const GET_MARKETPLACES_BEGIN = 'GET_MARKETPLACES_BEGIN'
export const GET_MARKETPLACES_SUCCESS = 'GET_MARKETPLACES_SUCCESS'
export const GET_MARKETPLACES_FAILURE = 'GET_MARKETPLACES_FAILURE'

//:: Subscription
export const POST_SUBSCRIPTION_BEGIN = 'POST_SUBSCRIPTION_BEGIN'
export const POST_SUBSCRIPTION_SUCCESS = 'POST_SUBSCRIPTION_SUCCESS'
export const POST_SUBSCRIPTION_FAILURE = 'POST_SUBSCRIPTION_FAILURE'

export const CANCEL_SUBSCRIPTION_BEGIN = 'CANCEL_SUBSCRIPTION_BEGIN'
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS'
export const CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE'

//:: Order
export const GET_ALL_ORDERS_BEGIN = 'GET_ALL_ORDERS_BEGIN'
export const GET_ALL_ORDERS_SUCCESS = 'GET_ALL_ORDERS_SUCCESS'
export const GET_ALL_ORDERS_FAILURE = 'GET_ALL_ORDERS_FAILURE'

export const CANCEL_ORDER_BEGIN = 'CANCEL_ORDER_BEGIN'
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS'
export const CANCEL_ORDER_FAILURE = 'CANCEL_ORDER_FAILURE'

//:: Sale
export const GET_CURRENT_SALE_BEGIN = 'GET_CURRENT_SALE_BEGIN'
export const GET_CURRENT_SALE_SUCCESS = 'GET_CURRENT_SALE_SUCCESS'
export const GET_CURRENT_SALE_FAILURE = 'GET_CURRENT_SALE_FAILURE'

//:: Financial
export const POST_GENERATE_CHARGE_BEGIN = 'POST_GENERATE_CHARGE_BEGIN'
export const POST_GENERATE_CHARGE_SUCCESS = 'POST_GENERATE_CHARGE_SUCCESS'
export const POST_GENERATE_CHARGE_FAILURE = 'POST_GENERATE_CHARGE_FAILURE'
export const CLEAR_CHARGE_INFO = 'CLEAR_CHARGE_INFO'
export const INSERT_INTO_CHARGE_CREATION = 'INSERT_INTO_CHARGE_CREATION'
export const GET_ISS_TAX_BEGIN = 'GET_ISS_TAX_BEGIN'
export const GET_ISS_TAX_SUCCESS = 'GET_ISS_TAX_SUCCESS'
export const GET_ISS_TAX_FAILURE = 'GET_ISS_TAX_FAILURE'
export const PUT_ISS_TAX_BEGIN = 'PUT_ISS_TAX_BEGIN'
export const PUT_ISS_TAX_SUCCESS = 'PUT_ISS_TAX_SUCCESS'
export const PUT_ISS_TAX_FAILURE = 'PUT_ISS_TAX_FAILURE'

//:: Plan Tables
export const GET_CURRENT_PLAN_TABLE_BEGIN = 'GET_CURRENT_PLAN_TABLE_BEGIN'
export const GET_CURRENT_PLAN_TABLE_SUCCESS = 'GET_CURRENT_PLAN_TABLE_SUCCESS'
export const GET_CURRENT_PLAN_TABLE_FAILURE = 'GET_CURRENT_PLAN_TABLE_FAILURE'
export const POST_CREATE_PLAN_TABLE_BEGIN = 'POST_CREATE_PLAN_TABLE_BEGIN'
export const POST_CREATE_PLAN_TABLE_SUCCESS = 'POST_CREATE_PLAN_TABLE_SUCCESS'
export const POST_CREATE_PLAN_TABLE_FAILURE = 'POST_CREATE_PLAN_TABLE_FAILURE'
export const PUT_UPDATE_PLAN_TABLE_BEGIN = 'PUT_UPDATE_PLAN_TABLE_BEGIN'
export const PUT_UPDATE_PLAN_TABLE_SUCCESS = 'PUT_UPDATE_PLAN_TABLE_SUCCESS'
export const PUT_UPDATE_PLAN_TABLE_FAILURE = 'PUT_UPDATE_PLAN_TABLE_FAILURE'
export const CLEAR_CURRENT_PLAN_TABLE_INFO = 'CLEAR_CURRENT_PLAN_TABLE_INFO'
export const INSERT_PLAN_TABLE_DATA = 'INSERT_PLAN_TABLE_DATA'
export const GET_PLAN_TABLES_BEGIN = 'GET_PLAN_TABLES_BEGIN'
export const GET_PLAN_TABLES_SUCCESS = 'GET_PLAN_TABLES_SUCCESS'
export const GET_PLAN_TABLES_FAILURE = 'GET_PLAN_TABLES_FAILURE'
export const POST_ADD_PLAN_BEGIN = 'POST_ADD_PLAN_BEGIN'
export const POST_ADD_PLAN_SUCCESS = 'POST_ADD_PLAN_SUCCESS'
export const POST_ADD_PLAN_FAILURE = 'POST_ADD_PLAN_FAILURE'
export const CLEAR_ADDED_PLANS = 'CLEAR_ADDED_PLANS'

//:: Plans
export const GET_ALL_VALID_PLANS_BEGIN = 'GET_ALL_VALID_PLANS_BEGIN'
export const GET_ALL_VALID_PLANS_SUCCESS = 'GET_ALL_VALID_PLANS_SUCCESS'
export const GET_ALL_VALID_PLANS_FAILURE = 'GET_ALL_VALID_PLANS_FAILURE'
export const CLEAR_PLANS = 'CLEAR_PLANS'
export const POST_CREATE_PLAN_BEGIN = 'POST_CREATE_PLAN_BEGIN'
export const POST_CREATE_PLAN_SUCCESS = 'POST_CREATE_PLAN_SUCCESS'
export const POST_CREATE_PLAN_FAILURE = 'POST_CREATE_PLAN_FAILURE'

//:: Wordpress API
export const GET_BLOG_POSTS_BEGIN = 'GET_BLOG_POSTS_BEGIN'
export const GET_BLOG_POSTS_SUCCESS = 'GET_BLOG_POSTS_SUCCESS'
export const GET_BLOG_POSTS_FAILURE = 'GET_BLOG_POSTS_FAILURE'

//:: Mail Verification
export const MAIL_VERIFICATION_REQUEST_BEGIN = 'MAIL_VERIFICATION_REQUEST_BEGIN'
export const MAIL_VERIFICATION_REQUEST_SUCCESS = 'MAIL_VERIFICATION_REQUEST_SUCCESS'
export const MAIL_VERIFICATION_REQUEST_FAILURE = 'MAIL_VERIFICATION_REQUEST_FAILURE'

//:: Checkout
export const INSERT_INTO_CHECKOUT_CREATION = 'INSERT_INTO_CHECKOUT_CREATION'

export const POST_CUSTOMER_CHECKOUT_BEGIN = 'POST_CUSTOMER_CHECKOUT_BEGIN'
export const POST_CUSTOMER_CHECKOUT_SUCCESS = 'POST_CUSTOMER_CHECKOUT_SUCCESS'
export const POST_CUSTOMER_CHECKOUT_FAILURE = 'POST_CUSTOMER_CHECKOUT_FAILURE'

//:: Filters
export const SET_FILTERS_MODAL = 'SET_FILTERS_MODAL'

export const GET_ALL_FILTERS_BEGIN = 'GET_ALL_FILTERS_BEGIN'
export const GET_ALL_FILTERS_SUCCESS = 'GET_ALL_FILTERS_SUCCESS'
export const GET_ALL_FILTERS_FAILURE = 'GET_ALL_FILTERS_FAILURE'

export const GET_FILTER_BEGIN = 'GET_FILTER_BEGIN'
export const GET_FILTER_SUCCESS = 'GET_FILTER_SUCCESS'
export const GET_FILTER_FAILURE = 'GET_FILTER_FAILURE'

export const POST_FILTER_BEGIN = 'POST_FILTER_BEGIN'
export const POST_FILTER_SUCCESS = 'POST_FILTER_SUCCESS'
export const POST_FILTER_FAILURE = 'POST_FILTER_FAILURE'

export const PUT_FILTER_BEGIN = 'PUT_FILTER_BEGIN'
export const PUT_FILTER_SUCCESS = 'PUT_FILTER_SUCCESS'
export const PUT_FILTER_FAILURE = 'PUT_FILTER_FAILURE'

export const DELETE_FILTER_BEGIN = 'DELETE_FILTER_BEGIN'
export const DELETE_FILTER_SUCCESS = 'DELETE_FILTER_SUCCESS'
export const DELETE_FILTER_FAILURE = 'DELETE_FILTER_FAILURE'

export const GET_FILTERED_USERS_BEGIN = 'GET_FILTERED_USERS_BEGIN'
export const GET_FILTERED_USERS_SUCCESS = 'GET_FILTERED_USERS_SUCCESS'
export const GET_FILTERED_USERS_FAILURE = 'GET_FILTERED_USERS_FAILURE'

//:: Notifications
export const SET_NOTIFICATIONS_MODAL = 'SET_NOTIFICATIONS_MODAL'

export const GET_ALL_NOTIFICATIONS_BEGIN = 'GET_ALL_NOTIFICATIONS_BEGIN'
export const GET_ALL_NOTIFICATIONS_SUCCESS = 'GET_ALL_NOTIFICATIONS_SUCCESS'
export const GET_ALL_NOTIFICATIONS_FAILURE = 'GET_ALL_NOTIFICATIONS_FAILURE'

export const POST_NOTIFICATION_BEGIN = 'POST_NOTIFICATION_BEGIN'
export const POST_NOTIFICATION_SUCCESS = 'POST_NOTIFICATION_SUCCESS'
export const POST_NOTIFICATION_FAILURE = 'POST_NOTIFICATION_FAILURE'

export const PUT_NOTIFICATION_BEGIN = 'PUT_NOTIFICATION_BEGIN'
export const PUT_NOTIFICATION_SUCCESS = 'PUT_NOTIFICATION_SUCCESS'
export const PUT_NOTIFICATION_FAILURE = 'PUT_NOTIFICATION_FAILURE'

export const DELETE_NOTIFICATION_BEGIN = 'DELETE_NOTIFICATION_BEGIN'
export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS'
export const DELETE_NOTIFICATION_FAILURE = 'DELETE_NOTIFICATION_FAILURE'

//:: Manager Log
export const GET_ALL_LOGS_BEGIN = 'GET_ALL_LOGS_BEGIN'
export const GET_ALL_LOGS_SUCCESS = 'GET_ALL_LOGS_SUCCESS'
export const GET_ALL_LOGS_FAILURE = 'GET_ALL_LOGS_FAILURE'